module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "goods-list-page"
    }
  }, [_c('div', {
    staticClass: "breadcrumb wrapper",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/landmark-superior-product"
    }
  }, [_vm._v("地标优品")])], 1), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.regionName))])]), _vm._v(" "), _c('div', {
    staticClass: "container wrapper clearfix"
  }, [_c('div', {
    staticClass: "right",
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "shop_con_list",
    attrs: {
      "id": "main-nav-holder"
    }
  }, [(!this.loading && this.list.length == 0) ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_vm._v("\n          抱歉,暂无此类商品!\n        ")]) : _vm._e(), _vm._v(" "), _c('right-goods', {
    attrs: {
      "data": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total>0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.page,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c98d2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landmark-goods-list/index.vue
// module id = 1538
// module chunks = 1